import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  GridItem,
  Input,
  Text,
  Select,
} from "@chakra-ui/react";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  getCompanies,
  getCompanyDetails,
} from "../../redux/company/CompanySlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { MultiSelect } from "chakra-multiselect";
import SelectSearch from "react-select-search";
import { getCompanyData, getCompanyUnit, getSellerUnits } from "../../api";

function TcFormCards1({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  handleSubmit,
  setErrors,
  setFieldValue,
  setFieldError,
  processValues,
  setProcessValues,
  selectedProcessValue,
  setSelectedProcessValue,
  customProcessValue,
  setCustomProcessValue,
  checkedItems,
  setCheckedItems,
  buyers,
  setBuyers,
  buyerId,
  setBuyerId,
  consigneeUnitId,
  setConsigneeUnitId,
  consigneeUnits,
  setConsigneeUnits,
  selectedConsigneeUnit,
  setSelectedConsigneeUnit,
  buyerCompany,
  setBuyerCompany,
  isConsigneeChecked,
  setIsConsigneeChecked,
  isLastProcessorChecked,
  setIsLastProcessorChecked,
  setUnitId,
  setTc1Error2,
  setTc1Error1,
  tc1error1,
  tc1error2,
  sellerUnits,
  setSellerUnits,
  setSellerOptions,
  sellerOptions,
  setSellerUnitId,
  sellerUnitId,
  tc1error3,
  setTc1Error3,
  setSelectedSellerUnit,
  selectedSellerUnit,
}) {
  const { userData } = useSelector((state) => state.auth);
  const { companyDetails } = useSelector((state) => state.company);
  const { allCompanies } = useSelector((state) => state.company);

  const dispatch = useDispatch();

  const handleCheckboxChange = (index) => {
    setCheckedItems((prevState) => {
      const updatedState = [...prevState];
      updatedState[index] = !updatedState[index];
      updatedState[1 - index] = false;
      return updatedState;
    });
  };

  const getCompany = () => {
    try {
      const result = dispatch(getCompanyDetails(userData?.companyId));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getBuyersData = async () => {
    let buyerOPtions = allCompanies?.data?.map((buyer) => {
      return {
        name: `${buyer?.name} (${buyer.license})`,
        value: buyer?._id,
      };
    });
    setBuyers(buyerOPtions);
  };

  const getBuyersCompany = async () => {
    const response = await getCompanyData(buyerId && buyerId);
    let buyerOPtions = response?.data?.company_units?.map((unit) => {
      return {
        name: `${unit?.name}`,
        value: unit?._id,
      };
    });
    setBuyerCompany(response?.data);
    setConsigneeUnits(buyerOPtions);
  };

  const getAllCompanies = async () => {
    let programId = values.certificationBodyId;

    try {
      const result = await dispatch(getCompanies({ programId }));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getUnits = async () => {
    const response = await getCompanyData(companyDetails?.data?._id);
    let formattedOptions = response?.data?.company_units?.map((unit) => {
      return {
        name: `${unit?.name}`,
        value: unit?._id,
      };
    });
    setSellerUnits(response?.data);
    setSellerOptions(formattedOptions);
  };

  const getBuyersCompanyUnit = async () => {
    const response = await getCompanyUnit(consigneeUnitId && consigneeUnitId);
    setSelectedConsigneeUnit(response?.data);
  };

  const getSellersCompanyUnit = async () => {
    const response = await getCompanyUnit(sellerUnitId && sellerUnitId);
    setSelectedSellerUnit(response?.data);
  };

  const handleConsigneeChange = (event) => {
    setIsConsigneeChecked(event.target.checked);
    if (event.target.checked) {
      handleChange({
        target: {
          id: "consigneeName",
          value: values.buyerName,
        },
      });
      handleChange({
        target: {
          id: "consigneeCountry",
          value: values.buyerCountry,
        },
      });
      handleChange({
        target: {
          id: "consigneeAddress",
          value: values.buyerAddress,
        },
      });
    }
  };

  const handleLastProcessorChange = (event) => {
    setIsLastProcessorChecked(event.target.checked);
    if (event.target.checked) {
      handleChange({
        target: {
          id: "lastProcessorName",
          value: companyDetails?.data?.name,
        },
      });
      handleChange({
        target: {
          id: "lastProcessorCountry",
          value: companyDetails?.data?.address?.country,
        },
      });
      handleChange({
        target: {
          id: "lastProcessorAddress",
          value: companyDetails?.data?.address?.raw_address,
        },
      });
    } else {
      handleChange({
        target: {
          id: "lastProcessorName",
          value: "",
        },
      });
      handleChange({
        target: {
          id: "lastProcessorCountry",
          value: "",
        },
      });
      handleChange({
        target: {
          id: "lastProcessorAddress",
          value: "",
        },
      });
    }
  };

  useEffect(() => {
    getAllCompanies();
  }, [values.certificationBodyId]);

  useEffect(() => {
    getBuyersData();
    getBuyersCompany();
  }, []);

  useEffect(() => {
    if (userData?.companyId) {
      getCompany();
    }
  }, [userData]);

  useEffect(() => {
    if (allCompanies) {
      getBuyersData();
    }
  }, [allCompanies]);

  useEffect(() => {
    if (buyerId) {
      getBuyersCompany();
    }
  }, [buyerId]);

  useEffect(() => {
    getUnits();
  }, [companyDetails]);

  useEffect(() => {
    if (consigneeUnitId) {
      getBuyersCompanyUnit();
    }
  }, [consigneeUnitId]);

  useEffect(() => {
    if (sellerUnitId) {
      getSellersCompanyUnit();
    }
  }, [sellerUnitId]);

  return (
    <>
      <Box marginTop="4rem">
        <Grid
          templateColumns={{ base: "1fr", md: "1fr", lg: "repeat(2, 1fr)" }}
          gap={{ base: "1rem", md: "1rem", xl: "0rem" }}
        >
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Unit &nbsp;
              <Text as="span" color="red">
                *
              </Text>
            </Text>
            <Select
              _placeholder={{
                opacity: 1,
                color: "#141D43",
                fontSize: "14px",
              }}
              color={"#141D43"}
              border="2px solid  #8fd0fd !important"
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              id="unitId"
              value={values.unitId}
              onChange={(e) => {
                handleChange(e);
                setUnitId(e.target.value);
              }}
              onBlur={handleBlur}
              _focusVisible={
                errors.unitId && touched.unitId
                  ? {
                      border: "1px solid red !important",
                    }
                  : { border: "1px solid #464C64" }
              }
            >
              <option hidden="true">Select Unit</option>
              {companyDetails?.data?.company_units?.map((unit, index) => (
                <option key={index} value={unit._id}>
                  {unit?.name} - {unit?.unitType}
                </option>
              ))}

              {errors.unitId && touched.unitId && (
                <Box color="red.500" marginTop={"2px"}>
                  {errors.unitId}
                </Box>
              )}
            </Select>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Certification Applying For &nbsp;
              <Text as="span" color="red">
                *
              </Text>
            </Text>
            <Select
              _placeholder={{
                opacity: 1,
                color: "#141D43",
                fontSize: "14px",
              }}
              color={"#141D43"}
              border="2px solid  #8fd0fd !important"
              marginTop="10px"
              w="80%"
              bg={"#fff"}
              id="certificationBodyId"
              value={values.certificationBodyId}
              onChange={handleChange}
              onBlur={handleBlur}
              _focusVisible={
                errors.certificationBodyId && touched.certificationBodyId
                  ? {
                      border: "1px solid red !important",
                    }
                  : { border: "1px solid #464C64" }
              }
            >
              <option hidden="true">Select Certification</option>
              {companyDetails?.data?.company_programs?.map((program, index) => (
                <option key={index} value={program._id}>
                  {program?.name}
                </option>
              ))}

              {errors.certificationBodyId && touched.certificationBodyId && (
                <Box color="red.500" marginTop={"2px"}>
                  {errors.certificationBodyId}
                </Box>
              )}
            </Select>
          </GridItem>
          {/* <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Select Processes &nbsp;
              <Text as="span" color="red">
                *
              </Text>
            </Text>
            <MultiSelect
              marginTop={"10px"}
              options={processValues}
              value={selectedProcessValue}
              placeholder="Select Processes"
              border="2px solid  #8fd0fd !important"
              onChange={(value) => {
                const newArr = value.map(
                  (value) =>
                    processValues.filter(
                      (process) => process.label === value
                    )[0]
                );
                setCustomProcessValue(newArr);
                setSelectedProcessValue(value);
              }}
            />
          </GridItem> */}
        </Grid>
      </Box>

      <Box>
        <Grid
          templateColumns={{ base: "1fr", md: "1fr", lg: "repeat(2, 1fr)" }}
          gap={"1rem"}
        >
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
            >
              <Box
                display={"flex"}
                justifyContent="right"
                alignItems={"center"}
                gap="20px"
              >
                <Box>
                  <Checkbox
                    colorScheme={"checkbox"}
                    defaultChecked
                    isChecked={checkedItems[1]}
                    onChange={() => handleCheckboxChange(1)}
                    fontWeight={"500"}
                  >
                    Non Registered
                  </Checkbox>
                </Box>
                <Box>
                  <Checkbox
                    colorScheme={"checkbox"}
                    fontWeight={"500"}
                    isChecked={checkedItems[0]}
                    onChange={() => handleCheckboxChange(0)}
                  >
                    Registered
                  </Checkbox>
                </Box>
              </Box>
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Buyer Details
              </Text>
              {checkedItems[0] && (
                <Box paddingLeft={"3rem"} mb="-1.4rem">
                  <Box width={"60%"} mt="1rem">
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      marginBottom="10px"
                    >
                      Buyer &nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <SelectSearch
                      options={buyers}
                      value={buyers?._id}
                      search
                      onChange={(e) => {
                        setBuyerId(e);
                        setTc1Error1(false);
                      }}
                      placeholder="Search and add Buyer"
                    />
                    {tc1error1 && <Box color="red.500">Buyer is required</Box>}
                  </Box>
                  <Box>
                    <Grid
                      alignItems={"flex-end"}
                      gap={"1rem"}
                      templateColumns="repeat(1, 1fr)"
                      marginTop={"10px"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent={"center"}
                      >
                        <Grid
                          width={"100%"}
                          templateColumns="repeat(2, 1fr)"
                          my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem colSpan={1}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Name
                            </Text>
                            <Input
                              type="tel"
                              color={"#141D43"}
                              id="buyerName"
                              value={buyerCompany?.name}
                              disabled
                              opacity={"1 !important"}
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              bg={"#fff"}
                              fontSize={"14px"}
                            />
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Liscense number
                            </Text>
                            <Input
                              type="tel"
                              color={"#141D43"}
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              bg={"#fff"}
                              w={"100%"}
                              value={buyerCompany?.license}
                              disabled
                              opacity={"1 !important"}
                              fontSize={"14px"}
                              _placeholder={{
                                opacity: 1,
                                color: "#141D43",
                                fontSize: "14px",
                              }}
                            />
                          </GridItem>
                        </Grid>
                        <GridItem width={"100%"}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Address
                          </Text>

                          <Input
                            type="tel"
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            fontSize={"14px"}
                            value={buyerCompany?.address?.raw_address}
                            disabled
                            opacity={"1 !important"}
                            _placeholder={{
                              opacity: 1,
                              color: "#141D43",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>
                      </Box>
                      <Box marginTop="35px"></Box>
                    </Grid>
                  </Box>
                </Box>
              )}
              {checkedItems[1] && (
                <Box paddingLeft={"3rem"} mb="1.6rem">
                  <Box>
                    <Grid
                      alignItems={"flex-end"}
                      gap={"1rem"}
                      templateColumns="repeat(1, 1fr)"
                      marginTop={"10px"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent={"center"}
                      >
                        <Grid
                          width={"100%"}
                          templateColumns="repeat(2, 1fr)"
                          my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem colSpan={1}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Name &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>

                            <Input
                              type="text"
                              color={"#141D43"}
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              bg={"#fff"}
                              id="buyerName"
                              value={values.buyerName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fontSize={"14px"}
                              _focusVisible={
                                errors.buyerName && touched.buyerName
                                  ? {
                                      border: "1px solid red !important",
                                    }
                                  : { border: "1px solid #464C64" }
                              }
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                            {errors.buyerName && touched.buyerName && (
                              <Box color="red.500">{errors.buyerName}</Box>
                            )}
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Country &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>
                            <Input
                              type="tel"
                              color={"#141D43"}
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              bg={"#fff"}
                              w={"100%"}
                              id="buyerCountry"
                              value={values.buyerCountry}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              _focusVisible={
                                errors.buyerCountry && touched.buyerCountry
                                  ? {
                                      border: "1px solid red !important",
                                    }
                                  : { border: "1px solid #464C64" }
                              }
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                            {errors.buyerCountry && touched.buyerCountry && (
                              <Box color="red.500">{errors.buyerCountry}</Box>
                            )}
                          </GridItem>
                        </Grid>
                        <GridItem width={"100%"}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Address &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>

                          <Input
                            type="tel"
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            id="buyerAddress"
                            value={values.buyerAddress}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            _focusVisible={
                              errors.buyerAddress && touched.buyerAddress
                                ? {
                                    border: "1px solid red !important",
                                  }
                                : { border: "1px solid #464C64" }
                            }
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                          {errors.buyerAddress && touched.buyerAddress && (
                            <Box color="red.500">{errors.buyerAddress}</Box>
                          )}
                        </GridItem>
                      </Box>
                      <Box marginTop="35px"></Box>
                    </Grid>
                  </Box>
                </Box>
              )}
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                <Box
                  as="span"
                  borderRight={"3px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Consignee Details
              </Text>
              {checkedItems[0] && (
                <Box paddingLeft={"3rem"}>
                  <Box width={"60%"} mt="1rem">
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                      marginBottom="10px"
                    >
                      Unit &nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <SelectSearch
                      options={consigneeUnits}
                      value={consigneeUnits?._id}
                      search
                      onChange={(e) => {
                        setConsigneeUnitId(e);
                        setTc1Error2(false);
                      }}
                      placeholder="Search and add Unit"
                    />
                    {tc1error2 && <Box color="red.500">Unit is required</Box>}
                  </Box>
                  <Box>
                    <Grid
                      alignItems={"flex-end"}
                      gap={"1rem"}
                      templateColumns="repeat(1, 1fr)"
                      marginTop={"10px"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent={"center"}
                      >
                        <Grid
                          width={"100%"}
                          templateColumns="repeat(1, 1fr)"
                          my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem colSpan={1}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Unit Name
                            </Text>
                            <Input
                              type="tel"
                              color={"#141D43"}
                              id="buyerName"
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              value={selectedConsigneeUnit?.name}
                              disabled
                              opacity={"1 !important"}
                              bg={"#fff"}
                              fontSize={"14px"}
                            />
                          </GridItem>
                        </Grid>
                        <GridItem width={"100%"}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Unit Address
                          </Text>

                          <Input
                            type="tel"
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            value={selectedConsigneeUnit?.address?.raw_address}
                            disabled
                            opacity={"1 !important"}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: "#141D43",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>
                      </Box>
                      <Box marginTop="35px"></Box>
                    </Grid>
                  </Box>
                </Box>
              )}
              {checkedItems[1] && (
                <Box
                  paddingLeft={"3rem"}
                  mb={
                    !values.buyerName &&
                    !values.buyerCountry &&
                    !values.buyerAddress
                      ? "3rem"
                      : ""
                  }
                >
                  <Box>
                    <Grid
                      alignItems={"flex-end"}
                      gap={"1rem"}
                      templateColumns="repeat(1, 1fr)"
                      marginTop={"10px"}
                    >
                      <Box
                        display={"flex"}
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent={"center"}
                      >
                        <Grid
                          width={"100%"}
                          templateColumns="repeat(2, 1fr)"
                          my={"1rem"}
                          gap="1rem"
                        >
                          <GridItem colSpan={1}>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Name &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>
                            <Input
                              type="text"
                              color={"#141D43"}
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              bg={"#fff"}
                              id="consigneeName"
                              opacity={"1 !important"}
                              value={
                                isConsigneeChecked
                                  ? values.buyerName
                                  : values.consigneeName
                              }
                              onChange={(e) => handleChange(e)}
                              onBlur={isConsigneeChecked ? "" : handleBlur}
                              disabled={isConsigneeChecked ? true : ""}
                              fontSize={"14px"}
                              _focusVisible={
                                errors.consigneeName && touched.consigneeName
                                  ? {
                                      border: "1px solid red !important",
                                    }
                                  : { border: "1px solid #464C64" }
                              }
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                            {isConsigneeChecked
                              ? ""
                              : errors.consigneeName &&
                                touched.consigneeName && (
                                  <Box color="red.500">
                                    {errors.consigneeName}
                                  </Box>
                                )}
                          </GridItem>
                          <GridItem>
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                            >
                              Country &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>
                            <Input
                              type="tel"
                              color={"#141D43"}
                              border="2px solid  #8fd0fd !important"
                              marginTop="10px"
                              bg={"#fff"}
                              w={"100%"}
                              id="consigneeCountry"
                              value={
                                isConsigneeChecked
                                  ? values.buyerCountry
                                  : values.consigneeCountry
                              }
                              onChange={(e) => handleChange(e)}
                              onBlur={isConsigneeChecked ? "" : handleBlur}
                              disabled={isConsigneeChecked ? true : ""}
                              opacity={"1 !important"}
                              _focusVisible={
                                errors.consigneeCountry &&
                                touched.consigneeCountry
                                  ? {
                                      border: "1px solid red !important",
                                    }
                                  : { border: "1px solid #464C64" }
                              }
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                            {isConsigneeChecked
                              ? ""
                              : errors.consigneeCountry &&
                                touched.consigneeCountry && (
                                  <Box color="red.500">
                                    {errors.consigneeCountry}
                                  </Box>
                                )}
                          </GridItem>
                        </Grid>
                        <GridItem width={"100%"}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Address &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>

                          <Input
                            type="tel"
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            id="consigneeAddress"
                            value={
                              isConsigneeChecked
                                ? values.buyerAddress
                                : values.consigneeAddress
                            }
                            opacity={"1 !important"}
                            onChange={(e) => handleChange(e)}
                            onBlur={isConsigneeChecked ? "" : handleBlur}
                            disabled={isConsigneeChecked ? true : ""}
                            _focusVisible={
                              errors.consigneeAddress &&
                              touched.consigneeAddress
                                ? {
                                    border: "1px solid red !important",
                                  }
                                : { border: "1px solid #464C64" }
                            }
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                          {isConsigneeChecked
                            ? ""
                            : errors.consigneeAddress &&
                              touched.consigneeAddress && (
                                <Box color="red.500">
                                  {errors.consigneeAddress}
                                </Box>
                              )}
                        </GridItem>
                      </Box>
                      {values.buyerName &&
                        values.buyerCountry &&
                        values.buyerAddress && (
                          <GridItem marginTop={"10px"}>
                            <Checkbox
                              colorScheme={"checkbox"}
                              onChange={handleConsigneeChange}
                              fontWeigh="500"
                            >
                              Same as Buyer Address
                            </Checkbox>
                          </GridItem>
                        )}
                      <Box marginTop="35px"></Box>
                    </Grid>
                  </Box>
                </Box>
              )}
            </Box>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Grid
          templateColumns={{ base: "1fr", md: "1fr", lg: "repeat(2, 1fr)" }}
          gap={"1rem"}
        >
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                Seller Details (Applicant)
              </Text>
              <Box
                border={"2px solid #2272D5"}
                width="15%"
                marginBottom={"1rem"}
                mt="1rem"
              ></Box>
              <Box paddingLeft={"3rem"} mb="4.5rem">
                <Box>
                  <Grid
                    alignItems={"flex-end"}
                    gap={"1rem"}
                    templateColumns="repeat(1, 1fr)"
                    marginTop={"1rem"}
                  >
                    <Box
                      display={"flex"}
                      flexDirection="column"
                      alignItems="flex-start"
                      justifyContent={"center"}
                    >
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(2, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Name
                          </Text>
                          <Input
                            type="text"
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            id="sellerName"
                            value={companyDetails?.data?.name}
                            disabled
                            opacity={"1 !important"}
                            // onBlur={handleBlur}
                            _focusVisible={
                              errors.sellerName && touched.sellerName
                                ? {
                                    border: "1px solid red !important",
                                  }
                                : { border: "1px solid #464C64" }
                            }
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                          {errors.sellerName && touched.sellerName && (
                            <Box color="red.500">{errors.sellerName}</Box>
                          )}
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Country
                          </Text>
                          <Input
                            type="tel"
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            id="sellerCountry"
                            value={companyDetails?.data?.address?.country}
                            disabled
                            opacity={"1 !important"}
                            _focusVisible={
                              errors.sellerCountry && touched.sellerCountry
                                ? {
                                    border: "1px solid red !important",
                                  }
                                : { border: "1px solid #464C64" }
                            }
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                          {errors.sellerCountry && touched.sellerCountry && (
                            <Box color="red.500">{errors.sellerCountry}</Box>
                          )}
                        </GridItem>
                      </Grid>
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          License
                        </Text>

                        <Input
                          type="tel"
                          color={"#141D43"}
                          marginTop="10px"
                          border="2px solid  #8fd0fd !important"
                          w="100%"
                          bg={"#fff"}
                          id="sellerCountry"
                          value={companyDetails?.data?.license}
                          disabled
                          opacity={"1 !important"}
                          _focusVisible={
                            errors.sellerAddress && touched.sellerAddress
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                        {errors.sellerAddress && touched.sellerAddress && (
                          <Box color="red.500">{errors.sellerAddress}</Box>
                        )}
                      </GridItem>
                      <GridItem width={"100%"} mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address
                        </Text>

                        <Input
                          type="tel"
                          color={"#141D43"}
                          marginTop="10px"
                          border="2px solid  #8fd0fd !important"
                          w="100%"
                          bg={"#fff"}
                          id="sellerCountry"
                          value={companyDetails?.data?.address?.raw_address}
                          disabled
                          opacity={"1 !important"}
                          _focusVisible={
                            errors.sellerAddress && touched.sellerAddress
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                        {errors.sellerAddress && touched.sellerAddress && (
                          <Box color="red.500">{errors.sellerAddress}</Box>
                        )}
                      </GridItem>
                    </Box>
                    <Box marginTop="35px"></Box>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg="#FFFFFF"
              padding={"2rem"}
              marginTop="2rem"
              borderRadius={"15px"}
            >
              <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
                Last Processor Details
              </Text>
              <Box
                border={"2px solid #2272D5"}
                width="15%"
                marginBottom={"1rem"}
                mt="1rem"
              ></Box>
              <Box paddingLeft={"3rem"}>
                <Box mb="5.7rem">
                  <Grid
                    alignItems={"flex-end"}
                    gap={"1rem"}
                    templateColumns="repeat(1, 1fr)"
                    marginTop={"1rem"}
                  >
                    <Box
                      display={"flex"}
                      flexDirection="column"
                      alignItems="flex-start"
                      justifyContent={"center"}
                    >
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(1, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem>
                          <Box width={"60%"} mt="1rem">
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"700"}
                              fontFamily={"font.roboto"}
                              marginBottom="10px"
                            >
                              Select Unit &nbsp;
                              <Text as="span" color="red">
                                *
                              </Text>
                            </Text>
                            <SelectSearch
                              options={sellerOptions}
                              value={sellerOptions?._id}
                              search
                              onChange={(e) => {
                                setSellerUnitId(e);
                                setTc1Error3(false);
                              }}
                              placeholder="Search and add Unit"
                            />
                            {tc1error3 && (
                              <Box color="red.500">Unit is required</Box>
                            )}
                          </Box>
                        </GridItem>
                      </Grid>
                      <Grid
                        width={"100%"}
                        templateColumns="repeat(2, 1fr)"
                        my={"1rem"}
                        gap="1rem"
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Name &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Input
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            id="lastProcessorName"
                            disabled
                            opacity={"1 !important"}
                            value={selectedSellerUnit?.name}
                            onChange={(e) => handleChange(e)}
                            // onBlur={isLastProcessorChecked ? "" : handleBlur}
                            // disabled={isLastProcessorChecked ? true : ""}
                            // _focusVisible={
                            //   errors.lastProcessorName &&
                            //     touched.lastProcessorName
                            //     ? {
                            //       border: "1px solid red !important",
                            //     }
                            //     : { border: "1px solid #464C64" }
                            // }
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                          {/* {isLastProcessorChecked
                            ? ""
                            : errors.lastProcessorName &&
                            touched.lastProcessorName && (
                              <Box color="red.500">
                                {errors.lastProcessorName}
                              </Box>
                            )} */}
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Country &nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </Text>
                          <Input
                            color={"#141D43"}
                            marginTop="10px"
                            border="2px solid  #8fd0fd !important"
                            w="100%"
                            bg={"#fff"}
                            fontSize={"14px"}
                            id="lastProcessorCountry"
                            disabled
                            opacity={"1 !important"}
                            value={selectedSellerUnit?.address?.country}
                            onChange={(e) => handleChange(e)}
                            // onBlur={isLastProcessorChecked ? "" : handleBlur}
                            // disabled={isLastProcessorChecked ? true : ""}
                            // _focusVisible={
                            //   errors.lastProcessorCountry &&
                            //     touched.lastProcessorName
                            //     ? {
                            //       border: "1px solid red !important",
                            //     }
                            //     : { border: "1px solid #464C64" }
                            // }
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                          {/* {isLastProcessorChecked
                            ? ""
                            : errors.lastProcessorName &&
                            touched.lastProcessorName && (
                              <Box color="red.500">
                                {errors.lastProcessorName}
                              </Box>
                            )} */}
                        </GridItem>
                      </Grid>
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>

                        <Input
                          color={"#141D43"}
                          marginTop="10px"
                          border="2px solid  #8fd0fd !important"
                          w="100%"
                          bg={"#fff"}
                          fontSize={"14px"}
                          id="lastProcessorAddress"
                          opacity={"1 !important"}
                          disabled
                          value={selectedSellerUnit?.address?.raw_address}
                          onChange={(e) => handleChange(e)}
                          // onBlur={isLastProcessorChecked ? "" : handleBlur}
                          // disabled={isLastProcessorChecked ? true : ""}
                          // _focusVisible={
                          //   errors.lastProcessorAddress &&
                          //     touched.lastProcessorAddress
                          //     ? {
                          //       border: "1px solid red !important",
                          //     }
                          //     : { border: "1px solid #464C64" }
                          // }
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                        {/* {isLastProcessorChecked
                          ? ""
                          : errors.lastProcessorAddress &&
                          touched.lastProcessorAddress && (
                            <Box color="red.500">
                              {errors.lastProcessorAddress}
                            </Box>
                          )} */}
                      </GridItem>
                    </Box>
                    {/* <GridItem marginTop={"10px"}>
                      <Checkbox
                        colorScheme={"checkbox"}
                        onChange={handleLastProcessorChange}
                      >
                        Same as Seller Address
                      </Checkbox>
                    </GridItem> */}
                  </Grid>
                </Box>
              </Box>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
}

export default TcFormCards1;
